import React from 'react';
import { Trans, withTranslation } from 'react-i18next';
import { hot } from 'react-hot-loader';

function Signatures() {
	return (
		<>
			<p className="justify">
				<Trans i18nKey="loan_agreement_guarantor_lender.signatures">
					<strong>Signatures</strong>
				</Trans>
			</p>
			<p className="justify">
				<Trans i18nKey="loan_agreement_guarantor_lender.signatures_witness">
					<strong>IN WITNESS WHEREOF, </strong>the PARTIES have executed this Accession Agreement at
					Place:____________________ as of the day and year first above written.
				</Trans>
			</p>
		</>
	);
}

export default hot(module)(withTranslation()(Signatures));
